import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
 
import { HomeOneComponent } from './home-one.component';
import { WeatherConditionsModule } from '../weather-conditions/weather-conditions.module';
import { ExchangeRatesModule } from '../exchange-rates/exchange-rates.module';
 import { TobicModule } from '../tobic/tobic.module';
import { LiveModule } from '../live/live.module';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { BreakingNewsModule } from '../breaking-news/breaking-news.module';
 
 

@NgModule({
  declarations: [
    HomeOneComponent
  ],
  imports: [
    CommonModule,
    NgbCarouselModule,
    HomeRoutingModule,
     WeatherConditionsModule, 
    ExchangeRatesModule,
    TobicModule,
    LiveModule,
    BreakingNewsModule
  ]
})
export class HomeModule { }
